"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AlarmIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.019 19h8a4 4 0 01-8 0z",
    opacity: ".6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 1c2.869 0 5.301 1.986 5.707 4.659l1.069 7.048c.137.905.804 1.662 1.724 1.956l.144.047c.811.26 1.356.976 1.356 1.782V17H2v-.517c0-.812.552-1.531 1.37-1.787l.13-.04c.92-.288 1.586-1.04 1.723-1.942l1.07-7.055C6.7 2.986 9.131 1 12 1z"
  })));
});
AlarmIcon.category = 'Notification';
var _default = AlarmIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/AlarmIcon.js
// module id = 1040
// module chunks = 0